import type { HttpErrorResponse } from '@angular/common/http';
import type {
  AddressCheckResult,
  GetAddressCheckPayload,
} from '@essent/address';
import { createAction, props } from '@ngrx/store';

const prefix = '[Eplus Address Form]';

export const getAddressCheck = createAction(
  `${prefix} Get Address`,
  props<GetAddressCheckPayload & { houseNumberAddition: string }>()
);

export const clearAddressCheck = createAction(`${prefix} Clear Address`);

export const getAddressSuccess = createAction(
  `${prefix} Get Address success`,
  props<AddressCheckResult>()
);

export const getAddressError = createAction(
  `${prefix} Get Address error`,
  props<{ response: HttpErrorResponse }>()
);
